<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import Sheet from '../Sheet.vue';

const props = defineProps({
    productId: {
        type: String
    },
    bgColor: {
        type: String,
        default: 'bg-white'
    }
});

const CONFIG = {
    domain: 'i6ea00-ak.myshopify.com',
    token: 'c7a6bd322a9fda3cf898349967ace5b2',
    productId: props.productId,
    moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
    scriptUrl: 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js',
    options: {
        product: {
            styles: {
                product: {
                    'font-size': '10px !important',
                    'margin-bottom': '5px !important'
                },
                title: {
                    'font-size': '11px !important',
                    'margin-bottom': '5px !important'
                },
                price: {
                    'font-size': '10px !important',
                    'margin-bottom': '5px !important'
                },
                prices: {
                    'font-size': '10px !important',
                    'margin-bottom': '5px !important'
                },
                compareAt: {
                    'font-size': '9px !important'
                },
                description: {
                    'font-size': '9px !important'
                },
                button: {
                    'background-color': '#353cee !important',
                    color: '#fff !important',
                    'border-radius': '0.5rem !important',
                    padding: '5px 5px !important',
                    'font-size': '10px !important'
                },
                buttonWrapper: {
                    'margin-top': '5px !important'
                },
                background: {
                    'background-color': props.bgColor + ' !important'
                }
            },
            buttonDestination: 'checkout',

            text: { button: 'Jetzt kaufen' }
        },

        option: {},
        cart: {
            text: {
                total: 'Subtotal',
                button: 'Checkout'
            }
        },
        toggle: {}
    }
};

const root = ref(null);
let uiInstance = null;

function loadShopifyScript(url) {
    return new Promise((resolve, reject) => {
        const w = window;

        if (w.ShopifyBuy?.UI) return resolve();

        const s = document.createElement('script');
        s.async = true;
        s.src = url;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error('Failed to load Shopify Buy Button SDK'));
        document.head.appendChild(s);
    });
}

async function initBuyButton() {
    const w = window;
    await loadShopifyScript(CONFIG.scriptUrl);

    const client = w.ShopifyBuy.buildClient({
        domain: CONFIG.domain,
        storefrontAccessToken: CONFIG.token
    });
    const ui = await w.ShopifyBuy.UI.onReady(client);

    uiInstance = ui.createComponent('product', {
        id: String(CONFIG.productId),
        node: root.value,
        moneyFormat: CONFIG.moneyFormat,
        options: CONFIG.options
    });
}

onMounted(() => {
    if (typeof window === 'undefined' || !root.value) return;

    initBuyButton().catch((err) => {
        console.error('[ShopifyBuyButton] init error', err);
    });
});

onBeforeUnmount(() => {
    try {
        if (uiInstance && typeof uiInstance.destroy === 'function') uiInstance.destroy();
    } catch (_) {}

    if (root.value) root.value.innerHTML = '';
});
</script>
<template>
    <Sheet compact class="w-fit" :bgColor="bgColor">
        <div ref="root" />
    </Sheet>
</template>
